import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import Loader from "./elements/Loader"
import { useState, useEffect } from "preact/hooks"

export default function Serp() {
    const {
        response: { products },
        loading
    } = useAppState()
    const foundProducts = products && products.total > 0
    const toggleButtonId = "toggle-mobile-sidebar"

    const [isSidebarVisible, setSidebarVisible] = useState(true);

    const handleSidebarToggle = (event) => {
        event.stopPropagation();
        setSidebarVisible((prev) => !prev);
    };

    const isCustomizerPage = window.location.href.includes("/collections/customizer");
    if(isCustomizerPage) { setSidebarVisible(false) }

    useEffect(() => {
        const initializeSidebarVisibility = () => {
            const isMobile = window.innerWidth <= 768;
            setSidebarVisible(!isMobile);
        };

        initializeSidebarVisibility();

        window.addEventListener("resize", initializeSidebarVisibility);

        return () => window.removeEventListener("resize", initializeSidebarVisibility);
    }, []);

    // if(!foundProducts && !loading){
    //     window.location.href = '/404'
    //     return
    // }

    return (
        <div class="ns-serp-container" data-nosto-element="search">

            {(foundProducts || (loading && foundProducts)) && (
                <Toolbar onToggle={handleSidebarToggle} isVisible={isSidebarVisible} />
            )}
            <div
                class="ns-results-container"
                style={loading ? 'position: relative;' : ''}
            >
                {loading && foundProducts ? (
                    <>
                        {!isCustomizerPage && <Sidebar onToggle={handleSidebarToggle} isVisible={isSidebarVisible} />}
                        <Loader />
                        <Products isSidebarVisible={isSidebarVisible} />
                    </>
                ) : loading ? (
                    <Loader />
                ) : foundProducts ? (
                    <>
                        {!isCustomizerPage && <Sidebar onToggle={handleSidebarToggle} isVisible={isSidebarVisible} />}
                        <div class={isSidebarVisible ? "ns-serp-right-3" : "ns-serp-right-4"}>
                            <Products isSidebarVisible={isSidebarVisible} />
                            <BottomToolbar />
                        </div>
                    </>
                ) : (
                    <NoResults />
                )}
            </div>
        </div>
    )
}
